__turbopack_context__.v({
  "body": "StaticPage-module__YIZtga__body",
  "kicker": "StaticPage-module__YIZtga__kicker",
  "lede": "StaticPage-module__YIZtga__lede",
  "note": "StaticPage-module__YIZtga__note",
  "noteBody": "StaticPage-module__YIZtga__noteBody",
  "noteTitle": "StaticPage-module__YIZtga__noteTitle",
  "page": "StaticPage-module__YIZtga__page",
  "prose": "StaticPage-module__YIZtga__prose",
  "section": "StaticPage-module__YIZtga__section",
  "title": "StaticPage-module__YIZtga__title",
});
